/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {CTCEntity} from '@ion/core/src/types/entities';

/**
 * Provides a utility hook for getting the bulk edit operation results for any entity via
 * its respective reducer ...
 *
 * ```typescript
 *
 *   import {useBulkEditResults} from '@ion/dls/src/hooks/';
 *   const bulkEditResult = useBulkEditResults('reducer');
 *
 * ```
 */
export const useBulkEditResults = (reducer: string): CTCEntity | CTCEntity[] => {
  return useSelector(({[reducer]: {bulkEdit}}) => bulkEdit?.result);
};

export default useBulkEditResults;
